<template>
  <div class="item">
    <span>界面大小調節</span>
    <el-input-number
      v-model="scale"
      @change="changeScale"
      :min="-10"
      :max="10"
      :step="1"
      label="界面大小調節"
      size="mini"
    ></el-input-number>
  </div>
</template>
<script>
import VoiceRoomEventEmitter from '@/components/VoiceRoom/voiceRoomEventBus';
import VoiceRoomEvent from '@/components/VoiceRoom/voiceRoomEvent';
export default {
  name: 'ChangeFontsize',
  props: {},
  data() {
    return {
      scale: parseFloat(localStorage.getItem('voiceRoomScale') || 0)
      //   fontSize: 0,
      //   preFontSize: 0
    };
  },
  watch: {},
  computed: {},
  methods: {
    // changeFontsize() {
    //   const element = document.getElementById('voice-room'); // 获取目标元素
    //   const children = element.getElementsByTagName('*'); // 获取元素下的所有子元素
    //   console.log(
    //     localStorage.getItem('voiceRoomFontSize'),
    //     this.fontSize,
    //     this.preFontSize
    //   );
    //   let num = this.fontSize - this.preFontSize;
    //   for (let i = 0; i < children.length; i++) {
    //     if (this.fontSize != this.preFontSize) {
    //       if (this.fontSize > this.preFontSize) {
    //         children[i].style.fontSize =
    //           parseInt(window.getComputedStyle(children[i]).fontSize) +
    //           num +
    //           'px'; // 字体大小加 1
    //         console.log(children[i].style.fontSize);
    //       } else {
    //         children[i].style.fontSize =
    //           parseInt(window.getComputedStyle(children[i]).fontSize) +
    //           num +
    //           'px'; // 字体大小减 1
    //         console.log(children[i].style.fontSize);
    //       }
    //     }
    //   }
    //   this.preFontSize = this.fontSize;
    //   localStorage.setItem('voiceRoomFontSize', this.fontSize);
    // }
    changeScale() {
      VoiceRoomEventEmitter.emit(VoiceRoomEvent.voiceRoomScale, this.scale );
    }
  },
  mounted() {
    window.onstorage = e => {
      if (e.key === 'voiceRoomScale') {
        this.scale = Number(e.newValue);
      }
    };
  }
};
</script>
<style lang="scss" scoped></style>
